import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/logo.png';

import LanguageToggle from './LanguageToggle';
import ContainerTranslation from "./ContainerTranslation";





class Header extends Component {



  constructor(props) {
      super(props)
      this.user = JSON.parse(localStorage.getItem("user"))
      this.domainName = window.location.hostname;
    this.state = {
      log: null,
      waiting: false,
      widthProgress: 0
    }
  }


    isRole(roleToCheck) {

        return (this.user.role === roleToCheck)

    }


  UNSAFE_componentWillMount() {
    this.setState({ log: this.props.authenticated })
  }

  UNSAFE_componentWillReceiveProps(NextProps) {

    if (NextProps.pourcentageForm !== this.state.widthProgress) {
      this.setState({ widthProgress: NextProps.pourcentageForm })
    }

    if (NextProps.form !== null) {
      this.setState({ log: NextProps.authenticated })
    }

  }

  renderUserName() {


    return (
      <div className="user">
            <p>{this.user.firstName} {this.user.lastName}</p>
        <Link to="/" style={{ marginLeft: "10px" }}><i className="fas fa-sign-out-alt"></i></Link>
      </div>
    )
  }

  // TODO IKOS Translate link
  renderLinks(isProjectManager) {

    const userFeatures = this.user.features;

    let route ;
    if (this.props.authenticated) {
      
      route = "/consultant/" + this.user.consultant._id

      let header = [];

      if (userFeatures.dashboard && (this.isRole('DirectorGeneral') || this.isRole('AssociateDirector') || this.isRole('SuperAdmin') || this.isRole('Admin'))){
        header.push( <li key={`${0}header`}>
                      <Link to="/dashboard"><p style={{marginTop:"20px",marginBottom:"0px",textAlign:'center'}}><ContainerTranslation id={"header." + ['Dashboard']} /></p></Link>
                      <p style={{marginTop:"0px",marginBottom:"0px",color:"red",textAlign:'center',fontSize:12}}>Version Alpha</p>
                    </li>)
      }
      header.push(<li key={`${1}header`}>
                    <Link to={route}><p><ContainerTranslation id={"header." + ['My Profile']} /><br></br> </p></Link>
                  </li>)
      if (userFeatures.consultant){
        header.push(<li key={`${2}header`}>
                    <Link to="/consultant"><p><ContainerTranslation id={"header." + ['Consultants']} /><br></br> </p></Link>
                    </li>)
      }
      if (userFeatures.project){
        header.push(<li key={`${3}header`}>
                      <Link to="/project"><p><ContainerTranslation id={"header." + ['Projects']} /><br></br> </p></Link>
                    </li>)
      }
      if (this.isRole('SuperAdmin') || this.isRole('Admin')){
        header.push(<li key={`${5}header`} className={(this.props.location === "/user" ? 'active' : '')}>
                      <Link to="/user"><p><ContainerTranslation id={"header." + ['Users']} /><br></br> </p></Link>
                    </li>)
      }

      if (userFeatures.program && (this.isRole('SuperAdmin') || this.isRole('Admin') || isProjectManager)){
        header.push(<li key={`${6}header`}>
                      <Link to="/program">
                        <p style={{marginTop:"20px",marginBottom:"0px",textAlign:'center'}}>Program</p>
                      </Link>
                    </li>)
      }
      if (userFeatures.rex && (this.isRole('SuperAdmin') || this.isRole('Admin') || isProjectManager)){
        header.push(<li key={`${7}header`}>
                      <Link to="/rex">
                        <p style={{marginTop:"20px",marginBottom:"0px",textAlign:'center'}}>Rex</p>
                      </Link>
                    </li>)
      }
      if (userFeatures.eightd && (this.isRole('SuperAdmin') || this.isRole('Admin') || isProjectManager)){
        header.push(<li key={`${8}header`}>
                      <Link to="/8D">
                        <p style={{marginTop:"20px",marginBottom:"0px",textAlign:'center'}}>8D</p>
                      </Link>
                    </li>)
      }
      if (userFeatures.chatbot){
        header.push(<li key={`${9}header`}>
                      <a href='https://10.107.0.3/askchatbot/'>
                      <p style={{marginTop:"20px",marginBottom:"0px",textAlign:'center'}}>Chatbot</p>
                      </a>
                    </li>)
      }                
      return header;
    } 
    
  }

  render() {


      if (this.user === undefined || window.location.pathname === "/"){
      return <></>
    }

    if (this.props.match.path === '/register' || this.props.match.path === '/' ||
        this.props.match.path === '/reset-password/:token' || this.props.match.path === '/forgot-password' ) {
        return (<div className="header">
            {
                this.domainName === "aegiscertogether.com" || (this.user && this.user.group === "aegis") ?
                    <img src="https://aegiscertification.com/wp-content/uploads/2023/03/cropped-ACE-Logo-1-1.png" className="aegis-logo" alt="Aegis Logo" /> :
                    <>
                        <img src={Logo} className="logo" alt="IKOS Logo" />
                        <li style={{ float: "right" }}>
                            <LanguageToggle />
                        </li>
                    </>

            }
      </div> )
    }
    else {
      return (
          <div className="header">
              {
                  this.user.group === "aegis" ? <img src="https://aegiscertification.com/wp-content/uploads/2023/03/cropped-ACE-Logo-1-1.png" className="aegis-logo" alt="Aegis Logo" /> :
                      <img src={Logo} className="logo" alt="IKOS Logo" />
              }
          { this.state.log ?
            this.renderUserName() : null
          }
          { document.location.pathname === "/formulaire" ?
            <div className="progress-bar" style={{ width: this.state.widthProgress + "%" }}></div> : null
          }
          <ul className="navbar">
                  {this.renderLinks(this.user.isProjectManager)}
                  <li style={{ float: "right" }}>
                      {this.user.group === "aegis"  ? null : <LanguageToggle />}
                  </li>
          </ul>
        </div>
      )
    }

  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    userId: state.auth.userId
  };
}

export default withRouter(connect(mapStateToProps)(Header));
